import { useState, useCallback } from 'react';
import axios from 'axios';
import { API_BASE } from '../utils/api';

const ENDPOINT = {
  geothermal: '/data/count',
  oilfield: '/oilfield/count',
  elements: '/elements/count',
} as const;

type CountType = keyof typeof ENDPOINT;

export const useCount = () => {
  const [count, setCount] = useState<number | null>(null);
  const fetchCount = useCallback(async (type: CountType, where?: string, countries?: string[]) => {
    try {
      const res = await axios.post(`${API_BASE}${ENDPOINT[type]}`, { data: { where, countries } });
      setCount(res.data?.count ?? 0);
    } catch { setCount(null); }
  }, []);
  return { count, fetchCount };
};
